import { useEffect, useState } from 'react'
import { UGELayer } from '../types'

export function useDuration(duration: number, layers: UGELayer[], hasFilter: boolean = false) {
    const [state, setState] = useState<number>(0)

    useEffect(() => {
        // if (duration > 1) {
        //     setState(duration)
        //     return
        // }

        const durations = [duration, ...layers.map((layer) => layer.duration)]
        const minDuration = hasFilter ? 1 : 0
        const maxDuration = Math.max.apply(Math, durations)

        if (isNaN(maxDuration)) {
            setState(minDuration)
        } else {
            setState(Math.max(minDuration, Math.round(maxDuration * 100) / 100))
        }
    }, [duration, hasFilter, layers])

    return state
}
